import React from 'react';

function PageNumber({currentPage = 1, limit = 10, totalCount = 0}) {
  const start = totalCount === 0 ? 0 : (currentPage - 1) * limit + 1;
  const end = Math.min(currentPage * limit, totalCount);
  const formattedTotalCount = totalCount?.toLocaleString();

  return (
    <div className="text-[#5C688E] text-sm font-medium">
      {start}-{end} of {formattedTotalCount}
    </div>
  );
}

export default PageNumber;
